<template>
  <div>
    <vs-table
      stripe
      search
      :sst="true"
      @search="handleSearch"
      :data="orders.orders">
      <template slot="thead">
        <vs-th style="min-width: 130px!important;">
          Date
        </vs-th>
        <vs-th style="min-width: 150px!important;">
          Name
        </vs-th>
        <vs-th>
          Phone
        </vs-th>
        <vs-th>
          Email
        </vs-th>
        <vs-th v-if="orders.zone_type === 'PUBLIC'">  
          Reference
        </vs-th>
        <vs-th v-else>  
          Employee ID 
        </vs-th>
        <vs-th style="min-width: 300px;">
          Trip
        </vs-th>
        <vs-th style="min-width: 200px;">
          Station in
        </vs-th>
        <vs-th style="min-width: 200px;">
          Station out
        </vs-th>
        <vs-th>
          Amount
        </vs-th>
        <vs-th>
          Status
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :key="index" v-for="(order ,index) in data">
          <vs-td>
            {{order.date}}
          </vs-td>
          <vs-td v-if="partner_namespace">

            {{order.customer.name}}
            
          </vs-td>
          <vs-td  v-else> 
            <router-link class="pointer" :to="{name: 'customers.detail', params: {id: order.customer.id}}"> {{order.customer.name}}</router-link>
          </vs-td>
          <vs-td>
            {{order.customer.phone}}
          </vs-td>
          <vs-td>
            {{order.customer.email}} 
           
          </vs-td>
          <vs-td  v-if="order.route.zone.type === 'PUBLIC'">
            {{order.reference_id}}
          </vs-td>
          <vs-td  v-else> 
            <router-link v-if="partner_namespace"  class="pointer" :to="{name:  'partner.users.history', params: {id: order.customer.id}}">{{order.customer.unlock_code}}</router-link>
            <router-link v-else  class="pointer" :to="{name:  'admin.users.history', params: {id: order.customer.id}}">{{order.customer.unlock_code}}</router-link>
          </vs-td>
          <vs-td>
            <router-link :to="showTrip(order.trip_id)">{{order.route.name}}</router-link>
          </vs-td>
          <vs-td>
            {{order.station_in.name}}
          </vs-td>
          <vs-td>
            {{order.station_out.name}}
          </vs-td>
          <vs-td>
            {{order.amount}}
          </vs-td>
          <vs-td>
            <vs-chip  color="success">
              {{order.status}}
            </vs-chip>
          </vs-td>
        </vs-tr>
      </template>

    </vs-table>
    <div class="mt-3 mb-3">
      <pagination :last-page="orders.pagination.pages" v-model="page" />
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  export default {
    props: {
      filters : {
        type : Object,
        default(){
          return {}
        }
      },
      type : {
        type : String,
        default(){
          return 'orders'
        }
      }
    },
    name: "list",
    data(){
      return {
        page : 0,
        orders : {
          orders : [],
          pagination : {
            page: 1,
            limit: 10,
            total: 0,
            pages: 0,
            prev: null,
            next: null
          },
          zone_type: 'PUBLIC'
        },
      }
    },
    computed : {
      ...mapState('orders',['currentPage']),
      ...mapState(['partner_namespace']),
    },
    watch : {
      page(newVal, oldVal){
        if(newVal !== oldVal){
          //this.$router.push({query: {page: newVal}});
          this.getItems();
        }
      },
      filters(newVal, oldVal){
        if(!_.isEqual(newVal, oldVal)){
          this.getItems();
        }
      },
    },
    created() {
      this.page = 1;
      this.doSearch = _.debounce(this.getItems,300);
    },
    methods : {
      ...mapActions('orders',['fetchOrders']),
      handleSearch(text){
        this.page = 1;
        this.doSearch(text);
      },
      getItems(search){
        if(this.page > 1 && this.page > this.orders.pagination.pages){
          this.page = this.orders.pagination.pages;
        }
        let payload = {
          page: this.page,
          type : this.type,
          ...this.filters,
        };
        if(search){
          let _filter = {field:'reference_id', op: 'like',value: search};
          if(payload.filters){
            payload.filters = [payload.filters, _filter];
          }else{
            payload.filters = [_filter];
          }
        }
        this.$vs.loading({type:'point'});
        this.fetchOrders(payload)
          .then(data=>{
            //console.log('data:', data)
            data.zone_type=data.orders[0].route.zone.type 
            this.orders = data;
            this.$vs.loading.close();
          })
          .catch(error=>{
            this.$vs.loading.close();
          })
      },
      showTrip(row){
        return { name: this.partner_namespace ? 'partner.trips.details':'trips details', params: {trip_id: row}};
      },
    }
  }
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
